import { useState } from 'react';
import { formatTRY } from '@/lib/currencyFormat';
import * as AccountsDB from '@/lib/personalAccountsDb';

interface CancelMovementModalProps {
  movement: AccountsDB.PersonalAccountMovement;
  onClose: () => void;
  onSuccess: () => void;
}

export default function CancelMovementModal({ movement, onClose, onSuccess }: CancelMovementModalProps) {
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!reason.trim()) {
      setErr('İptal nedeni zorunludur.');
      return;
    }
    setSaving(true);
    setErr(null);
    const res = await AccountsDB.cancelMovement(movement.id, reason.trim());
    setSaving(false);
    if (res.error) { setErr(res.error); return; }
    onSuccess();
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-background-50 rounded-xl w-full max-w-md shadow-lg">
        <div className="flex items-center justify-between p-5 border-b border-background-200">
          <h3 className="text-lg font-semibold text-foreground-900">Hareketi İptal Et</h3>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-background-100 cursor-pointer">
            <i className="ri-close-line text-lg text-foreground-500"></i>
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <div className="p-3 bg-background-100 rounded-lg text-sm space-y-1">
            <p><span className="text-foreground-400">Hareket No:</span> <span className="font-medium text-foreground-700">{movement.movement_no}</span></p>
            <p><span className="text-foreground-400">Tür:</span> <span className="font-medium text-foreground-700">{AccountsDB.MOVEMENT_TYPE_LABELS[movement.movement_type] || movement.movement_type}</span></p>
            <p><span className="text-foreground-400">Tutar:</span> <span className="font-medium text-foreground-700">{formatTRY(movement.principal_amount)}</span></p>
            <p><span className="text-foreground-400">Tarih:</span> <span className="font-medium text-foreground-700">{new Date(movement.movement_date).toLocaleDateString('tr-TR')}</span></p>
            {movement.product_name && (
              <p><span className="text-foreground-400">Ürün:</span> <span className="font-medium text-foreground-700">{movement.product_name}</span></p>
            )}
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">İptal Nedeni *</label>
            <textarea
              value={reason}
              onChange={e => setReason(e.target.value)}
              className="w-full px-3 py-2 text-sm bg-background-50 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-300 text-foreground-700 resize-none"
              rows={3}
              placeholder="Neden iptal ediyorsunuz?"
              required
              maxLength={500}
            />
          </div>

          <p className="text-xs text-foreground-400">
            <i className="ri-information-line mr-1"></i>
            Hareket silinmez, "iptal" olarak işaretlenir ve bakiye hesabından düşülür. Geçmişte görünmeye devam eder.
          </p>

          {err && (
            <div className="p-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700">{err}</div>
          )}

          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 text-sm font-medium text-foreground-600 bg-background-100 rounded-lg hover:bg-background-200 cursor-pointer whitespace-nowrap">
              Vazgeç
            </button>
            <button type="submit" disabled={saving} className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 cursor-pointer whitespace-nowrap">
              {saving ? 'İptal ediliyor...' : 'Hareketi İptal Et'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}